import React from "react";

export const DeclineIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
    >
      <g id="decline" transform="translate(-19.12 -19)">
        <circle
          id="Ellipse_120"
          data-name="Ellipse 120"
          cx="8.5"
          cy="8.5"
          r="8.5"
          transform="translate(19.12 19)"
          fill="#ee404c"
        />
        <path
          id="Path_225473"
          data-name="Path 225473"
          d="M44.892,51.664a.944.944,0,0,0,1.344,0l2.035-2.036,2.035,2.036a.951.951,0,0,0,1.344-1.344l-2.035-2.035,2.035-2.035A.951.951,0,0,0,50.307,44.9l-2.035,2.035L46.236,44.9a.951.951,0,0,0-1.344,1.344l2.035,2.035-2.035,2.035a.944.944,0,0,0,0,1.344Z"
          transform="translate(-20.678 -20.787)"
          fill="#fff7ed"
        />
      </g>
    </svg>
  );
};
